import { useTheme } from "./ThemeProvider";

/** Selector múltiple de opciones auxiliares (vistas). */
export default function MultiSelectAuxVistas({ rows = [], selectedIds = [], onChange, style = {}, disabled = false }) {
  const { theme } = useTheme();
  const c = theme.colors;

  const set = new Set((selectedIds || []).map(String));

  const toggle = (id) => {
    if (disabled) return;
    const sid = String(id);
    const next = set.has(sid) ? selectedIds.filter((x) => String(x) !== sid) : [...selectedIds, sid];
    onChange?.(next);
  };

  const chipStyle = (activo) => ({
    padding: "4px 10px",
    fontSize: 11,
    fontWeight: 500,
    borderRadius: 6,
    border: `1px solid ${activo ? c.chipActiveBorder : c.chipBorder}`,
    background: activo ? c.chipActiveBg : c.chipBg,
    color: activo ? c.chipActiveText : c.chipText,
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.15s ease",
    userSelect: "none",
    lineHeight: "1.4",
    opacity: disabled ? 0.6 : 1,
  });

  const onEnter = (e, activo) => {
    if (!activo) {
      e.currentTarget.style.background = c.chipHoverBg;
      e.currentTarget.style.color = c.chipHoverText;
      e.currentTarget.style.borderColor = c.chipHoverBorder;
    }
  };
  const onLeave = (e, activo) => {
    e.currentTarget.style.background = activo ? c.chipActiveBg : c.chipBg;
    e.currentTarget.style.color = activo ? c.chipActiveText : c.chipText;
    e.currentTarget.style.borderColor = activo ? c.chipActiveBorder : c.chipBorder;
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 5, ...style }}>
      {rows.map((row) => {
        const active = set.has(String(row.id));
        return (
          <button
            key={row.id}
            type="button"
            disabled={disabled}
            onClick={() => toggle(row.id)}
            style={chipStyle(active)}
            onMouseEnter={(e) => !disabled && onEnter(e, active)}
            onMouseLeave={(e) => !disabled && onLeave(e, active)}
          >
            {row.nombre}
          </button>
        );
      })}
      {rows.length === 0 && (
        <span style={{ fontSize: 12, color: c.textMuted }}>Sin opciones</span>
      )}
    </div>
  );
}
